import React from 'react'
import PropTypes from 'prop-types'
import ContactItem from './contact-item'

const ContactList = props => {
  const { contacts = [], isEditable, onEditContact, onDeleteContact } = props
  const renderContacts = contacts.map((contact, index) => (
    <ContactItem
      contact={contact}
      isEditable={isEditable}
      key={index}
      onEditContact={onEditContact}
      onDeleteContact={onDeleteContact}
    />
  ))
  return <div>{renderContacts}</div>
}

ContactList.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.object),
  isEditable: PropTypes.bool,
  onEditContact: PropTypes.func,
  onDeleteContact: PropTypes.func
}

export default ContactList



// WEBPACK FOOTER //
// ./src/ui/contacts/contact-list.js